// Custom MatterGen models (BYO weights / endpoint) — Firestore + llm-proxy helpers.
// Schema: /orgs/{orgId}/models/{modelId}. Non-secret metadata; the backend resolves
// the gcsUri/endpointUrl server-side (the client only ever handles the modelId + display fields).
import { collection, doc, getDocs, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { firestoreDb } from '../config/firebase';
import { authHeaders } from '../ai/authedFetch';

const db = firestoreDb;
const PROXY_BASE = (process.env.REACT_APP_GPT_API || 'http://localhost:8020/api/chat').replace(/\/api\/chat$/, '');

export async function listCustomModels(orgId) {
  if (!db || !orgId) return [];
  const snap = await getDocs(collection(db, 'orgs', orgId, 'models'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function saveCustomModel(orgId, model) {
  if (!db || !orgId) return null;
  const id = model.id || doc(collection(db, 'orgs', orgId, 'models')).id;
  const { id: _omit, ...fields } = model;
  await setDoc(
    doc(db, 'orgs', orgId, 'models', id),
    { ...fields, family: fields.family || 'mattergen', updatedAt: serverTimestamp() },
    { merge: true }
  );
  return id;
}

export async function deleteCustomModel(orgId, modelId) {
  if (!db || !orgId || !modelId) return;
  await deleteDoc(doc(db, 'orgs', orgId, 'models', modelId));
}

export async function verifyCustomModel(orgId, modelId) {
  const headers = { 'Content-Type': 'application/json', ...(await authHeaders()) };
  const resp = await fetch(`${PROXY_BASE}/models/verify`, {
    method: 'POST', headers, body: JSON.stringify({ orgId, modelId }),
  });
  return resp.json();
}

export async function getBucketVerifyToken(orgId) {
  const headers = { ...(await authHeaders()) };
  const resp = await fetch(`${PROXY_BASE}/models/verify-token?orgId=${encodeURIComponent(orgId)}`, { method: 'GET', headers });
  return resp.json();
}
